// A Squarehub CV that reached a client missing its work history is worse than no CV at all, so the
// sections a recruiter cannot send without are checked here rather than trusted from the extraction.
export const REQUIRED_SECTIONS = [
  { key: "role", label: "Job title", filled: (data) => Boolean((data.role || "").trim()) },
  { key: "profile", label: "Profile", filled: (data) => Boolean((data.profile || "").trim()) },
  {
    key: "experience",
    label: "Experience",
    // A role with no title is a placeholder the model emitted, not an experience.
    filled: (data) => (data.experience || []).some((row) => (row.title || "").trim()),
  },
  {
    key: "education",
    label: "Education",
    filled: (data) => (data.education || []).some((row) => (row.title || "").trim()),
  },
];

export const missingSections = (data) =>
  data ? REQUIRED_SECTIONS.filter((section) => !section.filled(data)) : [];

export const isIncomplete = (data) => missingSections(data).length > 0;

export const missingLabels = (data) => missingSections(data).map((section) => section.label);

export const incompleteMessage = (data) => {
  const labels = missingLabels(data);
  if (labels.length === 0) return null;

  const list =
    labels.length === 1
      ? labels[0]
      : `${labels.slice(0, -1).join(", ")} and ${labels[labels.length - 1]}`;
  return `${list} ${labels.length === 1 ? "is" : "are"} still empty — the CV was not extracted in full.`;
};
